import { useSmartList } from '../../../toolympus/hooks/useSmartList';

export interface CalculationRecord {
  _id?: string;
  title?: string;
  comment?: string;
  reference_id?: string;
  values?: Record<string, any>;
  calculator_config?: {
    inputs?: any[];
    rules?: any[];
    outputs?: any[];
    [key: string]: any;
  };
  created_at?: string;
  created_by?: string;
  updated_at?: string;
  updated_by?: string;
  [key: string]: any;
}

export const useCalculationsList = (calculatorId?: string, apiPath: string = '/api/calculations') => {
  const data = useSmartList<CalculationRecord>(apiPath, {
    extraParams: calculatorId ? { reference_id: calculatorId } : undefined,
    noLoad: !calculatorId,
    noView: true,
    noCount: true,
    schema: {},
    newRecordDefault: {},
    textFilterApi: {
      paramName: 'search',
    },
    skipTextFilter: true,
    getRecordApiPath: r => `${apiPath}/${r._id}`,
  });

  return data;
};
